import React, { useMemo } from "react";
import { Leaderboard } from "@/services/bedrock";
import { LeaderboardModal } from "@/components/LeaderboardModal";
import { LeaderboardTable } from "@/components/LeaderboardTable";

interface Props {
  playerId: number | string | undefined;
}

export function PlayerLeaderboards({ playerId }: Props) {
  const [showModal, setShowModal] = React.useState<boolean>(false);
  const [modalBoard, setModalBoard] = React.useState<Leaderboard>();

  const leaderboards: Leaderboard[] = useMemo(() => {
    const boards: Leaderboard[] = [
      { title: "Top Posts", entityType: "post" },
      { title: "Top Accounts", entityType: "social_identity", startTimeKey: "all" },
      { title: "Top Video Pages", entityType: "content_page" },
    ];

    return boards;
  }, []);

  return (
    <div className="flex flex-col gap-6 w-full max-w-5xl">
      {leaderboards.map(board => (
        <LeaderboardTable
          key={`leaderboard-${board.entityType}`}
          title={board.title}
          entityType={board.entityType}
          playerIdFilter={playerId}
          onViewAll={(startTimeKey, metric) => {
            setModalBoard({
              ...board,
              startTimeKey,
              metric,
            });
            setShowModal(true);
          }}
        />
      ))}
      <LeaderboardModal open={showModal} onClose={() => setShowModal(false)} board={modalBoard} />
    </div>
  );
}
